import { makeStyles } from "@material-ui/core";

export const AccessStyle = makeStyles((theme) => ({
    listWrapper: {
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        "& ul": {
            flex: '1'
        }
    },
    listItem: {
        borderBottom: '1px solid lightgrey',
        '&:last-of-type': {
            border: 'none'
        }
    },
    footer: {
        display: 'flex',
        margin: '1rem auto'
    },
    typeWrapper: {
        marginBottom: '1rem',
        padding: '1rem'
    },
    expiringSoonWrapper: {
        display: 'flex',
        alignItems: 'center',
        border: `1px solid #3f8ef6`,
        borderRadius: theme.shape.borderRadius,
        padding: '5px 12px 5px',
        minHeight: '36px',
    },
    expiringSoonLabel: {
        color: "#3f8ef6",
        fontWeight: 500
    }
}));